/* HDC Winter-Produktseiten – Auswahlkarten, Bedarfsrechner, Liefertermin. 12.10.2026 */
(function () {
  'use strict';

  function themeInputs(index) {
    return Array.prototype.slice.call(
      document.querySelectorAll('variant-picker fieldset[data-index="' + index + '"] input.js-option')
    );
  }

  /* Theme-Option setzen, Preis/Variante/Sticky-Leiste aktualisiert das Theme selbst */
  function selectOption(index, value) {
    var input = themeInputs(index).filter(function (i) { return i.value === value; })[0];
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function currentOption(index) {
    var input = themeInputs(index).filter(function (i) { return i.checked; })[0];
    return input ? input.value : null;
  }

  function setQuantity(n) {
    var q = document.querySelector('.js-product-form-main [name="quantity"], product-info [name="quantity"], [name="quantity"]');
    if (!q) return;
    q.value = n;
    q.dispatchEvent(new Event('change', { bubbles: true }));
    q.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---------------------------------------------------------- Karten */
  function initCards(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-value]'));
    function sync() {
      var cur = currentOption(1);
      var zu = currentOption(2);
      cards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-value') === cur);
        /* Preis je Zustellung (Lieferung/Abholung) aus data-map, 03.11.2026 */
        var map = null;
        try { map = JSON.parse(c.getAttribute('data-map') || 'null'); } catch (e) {}
        var row = map && zu && map[zu];
        if (!row) return;
        var p = c.querySelector('.hdc-w-card__price'), u = c.querySelector('.hdc-w-card__unit');
        if (p) p.textContent = row.p;
        if (u) u.textContent = row.u;
      });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () {
        selectOption(1, c.getAttribute('data-value'));
        cards.forEach(function (x) { x.classList.toggle('is-active', x === c); });
      });
    });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-picker input.js-option')) setTimeout(sync, 0);
    });
    sync();
  }

  /* ---------------------------------------------------------- Rechner */
  function initCalc(root) {
    var type = root.getAttribute('data-hdc-w-calc');

    if (type === 'choice') {
      var opts = Array.prototype.slice.call(root.querySelectorAll('[data-pick]'));
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          opts.forEach(function (x) { x.classList.toggle('is-active', x === o); });
          selectOption(1, o.getAttribute('data-pick'));
          var cards = document.querySelector('.hdc-w-cards');
          if (cards) cards.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      return;
    }

    if (type === 'salt') {
      var area = root.querySelector('[data-area]');
      var days = root.querySelector('[data-days]');
      var out = root.querySelector('[data-out]');
      var outSub = root.querySelector('[data-out-sub]');
      var apply = root.querySelector('[data-apply]');
      var gram = parseFloat(root.getAttribute('data-gram') || '15');
      var big = root.getAttribute('data-big'), small = root.getAttribute('data-small');
      var rec = { value: big, qty: 1 };

      function calc() {
        var a = Math.max(0, parseFloat(area.value) || 0);
        var d = Math.max(0, parseFloat(days.value) || 0);
        var kg = Math.ceil(a * d * gram / 1000);
        if (kg <= 5) rec = { value: small, qty: 1, label: '1 × 5-kg-Sack' };
        else if (kg <= 10) rec = { value: small, qty: 2, label: '2 × 5-kg-Sack' };
        else { var n = Math.ceil(kg / 25); rec = { value: big, qty: n, label: n + ' × 25-kg-Sack' }; }
        out.textContent = 'Empfehlung: ' + rec.label;
        outSub.textContent = 'ca. ' + kg + ' kg für die Saison';
      }
      area.addEventListener('input', calc);
      days.addEventListener('input', calc);
      apply.addEventListener('click', function () {
        selectOption(1, rec.value);
        setTimeout(function () { setQuantity(rec.qty); }, 150);
        apply.textContent = 'Übernommen ✓';
        setTimeout(function () { apply.textContent = 'Übernehmen'; }, 1800);
      });
      calc();
    }
  }

  /* ---------------------------------------------------------- Liefertermin */
  var DAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  function addWorkdays(date, n) {
    var d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }
  function fmt(d) {
    return DAYS[d.getDay()] + ', ' + ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.';
  }

  function initEta(root) {
    var cutoff = parseInt(root.getAttribute('data-cutoff') || '12', 10);
    function render() {
      var pickup = /abholung/i.test(currentOption(2) || '');
      var key = pickup ? 'pickup' : 'ship';
      var min = parseInt(root.getAttribute('data-' + key + '-min'), 10);
      var max = parseInt(root.getAttribute('data-' + key + '-max'), 10);
      var tpl = root.getAttribute('data-' + key + '-text');
      var sub = root.getAttribute('data-' + key + '-sub') || '';
      if (!tpl) return;
      var now = new Date();
      var start = now.getHours() >= cutoff ? addWorkdays(now, 1) : now;
      var text = tpl.replace('{von}', fmt(addWorkdays(start, min))).replace('{bis}', fmt(addWorkdays(start, max)));
      root.querySelector('[data-eta-text]').innerHTML = text;
      root.querySelector('[data-eta-sub]').textContent = sub;
      root.querySelector('[data-eta-ico]').textContent = pickup ? '📍' : root.getAttribute('data-icon') || '🚚';
      /* Abholung: Symbole und Kalender-Beschriftung der Liefertermin-App anpassen, 04.11.2026 */
      document.querySelectorAll('[data-hdc-w-ship-only]').forEach(function (el) { el.hidden = pickup; });
      document.querySelectorAll('[data-hdc-w-pickup-only]').forEach(function (el) { el.hidden = !pickup; });
      labelCalendar(pickup);
    }
    function labelCalendar(pickup) {
      var tries = 0;
      (function apply() {
        var head = document.querySelector('.odd_calender_heading');
        var input = document.querySelector('.odd-product-calendar .odd-input-text');
        if (head) head.textContent = pickup ? 'Wählen Sie Ihren Abholtag' : 'Wählen Sie einen Wunschtermin';
        if (input) input.placeholder = pickup ? 'Abholdatum auswählen' : 'Lieferdatum auswählen';
        if ((!head || !input) && tries++ < 20) setTimeout(apply, 250);
      })();
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-picker input.js-option')) setTimeout(render, 0);
    });
    render();
  }

  /* ---------------------------------------------------------- Grundpreis */
  function initUnit(root) {
    var mapEl = document.querySelector('[data-hdc-w-unit-map]');
    if (!mapEl) return;
    var map = {};
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }
    function render() {
      var id = (document.querySelector('.js-product-form-main [name="id"]') || {}).value;
      var txt = map[id];
      root.hidden = !txt;
      if (txt) root.querySelector('[data-unit-text]').textContent = txt;
    }
    document.addEventListener('change', function () { setTimeout(render, 50); });
    render();
  }

  /* ---------------------------------------------------------- Sprung zum Kaufbereich */
  function initJump() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-hdc-w-buy]');
      if (!a) return;
      e.preventDefault();
      var target = document.querySelector('.hdc-w-cards') || document.querySelector('.js-product-form-main');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function init() {
    document.querySelectorAll('.hdc-w-cards').forEach(initCards);
    document.querySelectorAll('[data-hdc-w-calc]').forEach(initCalc);
    document.querySelectorAll('[data-hdc-w-eta]').forEach(initEta);
    document.querySelectorAll('[data-hdc-w-unit]').forEach(initUnit);
    initJump();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

